export default __webpack_public_path__ + "static/media/28.60db2063.jpg";